module.exports = __webpack_public_path__ + "static/media/sliders-v.45d46ed0.svg";